import React from 'react'
import { Stack, Typography } from '@mui/material'
import { useHistory } from 'react-router'

interface ExploreButtonProps {
  icon: string | React.ReactNode
  title: string
  fullWidth?: boolean
  route?: string
  onClick?: () => void
}

export const ExploreButton: React.FC<ExploreButtonProps> = ({
  icon,
  title,
  fullWidth,
  route,
  onClick,
}) => {
  const history = useHistory()

  const iconNode =
    typeof icon === 'string' ? (
      <img src={icon} alt="" style={{ width: 24, height: 24 }} />
    ) : (
      <span
        style={{
          width: 24,
          height: 24,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icon}
      </span>
    )

  return (
    <Stack
      direction="row"
      spacing={2}
      flexShrink={0}
      sx={{
        border: '1px solid #DCDBDC',
        borderRadius: '8px',
        padding: '8px 16px',
        cursor: 'pointer',
        width: fullWidth ? 'unset' : 'fit-content',
        flexGrow: fullWidth ? 1 : 0,
        scrollSnapAlign: 'center',
      }}
      onClick={() => {
        if (route) history.push(route)
        else if (onClick) onClick()
      }}
    >
      {iconNode}
      <Typography variant="body1" sx={{ fontSize: '14px' }} color="primary">
        {title}
      </Typography>
    </Stack>
  )
}
